<template>
  <div class="widget">
    <div class="widget-content widget-content-mini themed-background-dark-default text-light">
      <div class="row">
        <div class="col-8">Información de contacto</div>
        <div class="col-2 text-right">
          <timer />
        </div>
        <span class="text-right text-muted col-2">
          <router-link to="/">
            <button class="btn btn-xs btn-primary">
              Salir &nbsp;
              <i class="fa fa-sign-out-alt"></i>
            </button>
          </router-link>
        </span>
      </div>
    </div>
    <div class="widget-content border-bottom themed-background-muted text-center" v-if="Object.keys(deudor).length > 0">
      <div class="col">
        <div class="row">
          <label for class="col-1 pl-0 text-right">
            <strong>Identificación</strong>
          </label>
          <div class="col-3 pl-0 pr-0 text-left">
            {{ deudor.tipo_identificacion }} - {{ deudor.identificacion }}
          </div>
          <label for class="col-1 pl-0 text-right">
            <strong>Nombre</strong>
          </label>
          <div class="col-3 pl-0 pr-0 text-left">{{ deudor.nombre }}</div>
          <label for class="col-1 pl-0 text-right">
            <strong>Género</strong>
          </label>
          <div class="col-3 pl-0 pr-0 text-left">{{ deudor.genero }}</div>
        </div>
      </div>

      <div class="row">
        <template v-for="(contacto, index) in contactos">
          <div class="col-4 info-contacto mt-3 mb-2 pl-3 pr-3 border-bottom" :key="index">
            <div class="row info-contacto-header">
              <strong class="pl-3">{{ index | capitalize }}</strong>
            </div>
            <template v-for="(campo, _index) in contactos[index]">
              <div class="row info-contacto-content" style="cursor: pointer" :key="_index">
                <div class="col-8 text-left pl-3 pr-0" v-if="campo.descripcion == 'telefono'">
                  {{ campo.valor | phone }}
                  <span v-if="campo.municipio != null && campo.municipio.id != null">- {{ campo.municipio.municipio }} /
                    {{ campo.municipio.departamento }}</span>
                </div>

                <div class="col-8 text-left pl-3 pr-0" v-else v-tooltip.top="Math.abs(campo.calificacion) +
                  (campo.calificacion > 0 ? ' Me gusta' : ' No me gusta')
                  ">
                  {{ campo.valor }}
                  <span v-if="campo.municipio != null && campo.municipio.id != null">- {{ campo.municipio.municipio }} /
                    {{ campo.municipio.departamento }}</span>
                </div>

                <div class="col-4 icon-actions pl-3 pr-2 text-right">
                  <btn-group>
                    <btn v-for="(item, index) in campo.tipo_notificacion" :key="index" size="xs" v-tooltip.top="'Autorizado vía: ' + item.titulo
                      " v-if="item.check" :class="'active'" aria-pressed="true">
                      <font-awesome-icon v-if="item.value == 'whatsapp'"
                        :icon="['fab', 'whatsapp']"></font-awesome-icon>
                      <font-awesome-icon v-if="item.value == 'telefono'"
                        :icon="['fas', 'phone-alt']"></font-awesome-icon>
                      <font-awesome-icon v-if="item.value == 'sms'" :icon="['far', 'comment-alt']"></font-awesome-icon>
                      <font-awesome-icon v-if="item.value == 'correo_electronico'"
                        :icon="['far', 'envelope']"></font-awesome-icon>
                    </btn>
                    <btn size="xs" v-tooltip.top="'Este dato de contacto fue marcado como Notificable'
                      " v-if="campo.notificable == 1" :class="'active'" aria-pressed="true">
                      <font-awesome-icon :icon="'check-double'"></font-awesome-icon>
                    </btn>
                    <btn size="xs" v-tooltip.top="'Comunicación Exitosa'" @click="likeContacto(campo)"
                      :disabled="campo.calificado">
                      <!---Like-->
                      <font-awesome-icon :icon="'thumbs-up'"></font-awesome-icon>
                      <span class="ml-1" v-html="campo.calificacion >= 0
                        ? Math.abs(campo.calificacion)
                        : ''
                        "></span>
                    </btn>
                    <btn size="xs" v-tooltip.top="'Comunicación Fallida'" @click="dislikeContacto(campo)"
                      :disabled="campo.calificado">
                      <!--Dislike-->
                      <font-awesome-icon :icon="'thumbs-down'"></font-awesome-icon>
                      <span class="ml-1" v-html="campo.calificacion < 0
                        ? Math.abs(campo.calificacion)
                        : ''
                        "></span>
                    </btn>
                    <btn size="xs" v-tooltip.top="'Tipo notificación'" @click="modalTipoContacto(campo)"
                      v-if="campo.descripcion == 'telefono' || campo.descripcion == 'email'">
                      <!--Dislike-->
                      <font-awesome-icon :icon="['fas', 'circle']"></font-awesome-icon>
                    </btn>
                    <dropdown menu-right>
                      <btn size="xs" class="dropdown-toggle" v-tooltip.top="'Más opciones'">
                        <font-awesome-icon :icon="'bars'"></font-awesome-icon>
                        <span class="caret"></span>
                      </btn>
                      <template slot="dropdown">
                        <li @click="marcarNotificable(campo)">
                          <!---Notificable-->
                          <a role="button">
                            <font-awesome-icon :icon="campo.notificable ? 'comment-slash' : 'comments'
                              "></font-awesome-icon>
                            <span style="margin-left: 10px" v-html="campo.notificable ? 'No notificar' : 'Notificar'
                              "></span>
                          </a>
                        </li>
                        <li @click="invalidarContacto(campo)">
                          <!--Invalid-->
                          <a role="button">
                            <font-awesome-icon :icon="campo.invalido ? 'exclamation-triangle' : 'bell'
                              "></font-awesome-icon>
                            <span style="margin-left: 10px" v-html="campo.invalido ? 'Dato inválido' : 'Reportar'
                              "></span>
                          </a>
                        </li>
                        <li v-if="index != 'email'" @click="openModalCiudad(campo)">
                          <a role="button">
                            <!--Cambiar Ciudad-->
                            <font-awesome-icon :icon="'map-marked-alt'"></font-awesome-icon>
                            <span style="margin-left: 10px">Ciudad</span>
                          </a>
                        </li>
                        <li role="separator" class="divider" v-if="index == 'telefono'"></li>
                        <li v-if="index == 'telefono'" @click="externalCall(57, campo.valor)">
                          <a role="button" v-tooltip.top="'Llamar al numero ' + campo.valor">
                            <!--external call-->
                            <font-awesome-icon :icon="'phone'"></font-awesome-icon>
                            <span style="margin-left: 10px">Llamar</span>
                          </a>
                        </li>
                      </template>
                    </dropdown>

                  </btn-group>
                  <!-- btn-group-nesting.vue -->
                </div>

              </div>
            </template>
          </div>
        </template>
      </div>

      <div class="row">
        <div class="col d-flex align-items-center justify-content-between my-3">
          <span>
            La última actualización de datos se realizó el:
            <b>{{ contacto_last_update | formatDate }}</b>
          </span>

          <button type="button" class="btn btn-secondary ms-3" @click="consultaAmpliada">
            Ampliar búsqueda
          </button>
        </div>
      </div>

      <div class="row mt-2">
        <div style="width: 100%;" class="btn-container">
          <router-link :to="'/informacion-contacto/' + deudor.identificacion"
            class="btn btn-sm btn-info">Inicio</router-link>
          <router-link :to="'/historico_gestion/' + deudor.id" class="btn btn-sm btn-info">Histórico de
            Gestión</router-link>
          <router-link :to="'/historico_abonos/' + deudor.id" class="btn btn-sm btn-info">Histórico de
            Abonos</router-link>
          <router-link :to="'/referencias_deudor/' + deudor.id" class="btn btn-sm btn-info">Referencias del
            deudor</router-link>
          <router-link :to="'/gestion/' + deudor.id" class="btn btn-sm btn-info">Nueva Gestión</router-link>
          <router-link :to="'/acuerdos_pago/' + deudor.identificacion" class="btn btn-sm btn-info">Histórico de Acuerdos
            de Pago</router-link>
          <button class="btn btn-sm btn-info" @click.prevent @click="modal = !modal">
            Crear Contacto
          </button>
          <button class="btn btn-sm btn-info" @click.prevent @click="getSocioDemografica()"
            :disabled="!this.modal_demografico_permiso">
            Inf. Demográfica
          </button>
        </div>
      </div>

      <modal class="modal" v-model="modal">
        <form @submit.prevent="addContacto">
          <div class="container">
            <div class="row mt-2">
              <label for="valor" class="col-3 control-label text-right">
                <strong>Descripcion</strong>
              </label>
              <div class="col-9">
                <select v-model="contacto.descripcion" class="form-control">
                  <option selected="Seleccione..."></option>
                  <option value="telefono">Telefono</option>
                  <option value="email">E-mail</option>
                  <option value="direccion">Direccion</option>
                </select>
              </div>
            </div>

            <div class="row mt-2" v-if="contacto.descripcion == 'telefono' || contacto.descripcion == 'email'">
              <ul class="custom-list">
                <p>
                  <strong>Seleccione uno o varios elementos de la lista:</strong>
                </p>
                <li v-for="(option, index) in (contacto.descripcion == 'telefono' ? data_telefono : data_email)"
                  :key="index">
                  <label>
                    <input :disabled="loading" type="checkbox" v-model="option.check" :value="option.check"> {{
                      option.titulo }}
                  </label>
                </li>
              </ul>
            </div>

            <div class="row mt-2">
              <label for="valor" class="col-3 control-label text-right">
                <strong>Valor</strong>
              </label>
              <div class="col-9">
                <input type="text" v-model="contacto.valor" id="valor" class="form-control" placeholder="Valor" />
              </div>
            </div>
          </div>
        </form>
        <span slot="footer">
          <btn type="button" class="btn btn-primary" @click="modal = !modal">Cancelar</btn>&nbsp;
          <btn type="button" class="btn btn-primary" @click="addContacto">{{
            contacto.id ? "Editar" : "Guardar"
          }}</btn>&nbsp;
        </span>
      </modal>

      <modal class="modal" v-model="modal_ciudad.visible" title="Actualizar ciudad de contacto">
        <form @submit.prevent="false">
          <div class="container">
            <p>
              Por favor seleccione la ciudad a la que pertenece el dato de
              contacto:
              <b>{{ modal_ciudad.contacto_selected.valor }}</b> actualmente
              tiene asignada la ciudad:
              <b v-if="modal_ciudad.contacto_selected.municipio">{{ modal_ciudad.contacto_selected.municipio.municipio
              }} /
                {{ modal_ciudad.contacto_selected.municipio.departamento }}</b>
            </p>
            <div class="row mt-2">
              <input id="input" class="form-control" type="text" placeholder="Buscar..." autocomplete="off" />
              <typeahead v-model="modal_ciudad.ciudad_selected" target="#input" :data="modal_ciudad.ciudades"
                item-key="name" class="typehead" />
            </div>
          </div>
        </form>
        <span slot="footer">
          <btn type="button" class="btn btn-primary" @click="modal_ciudad.visible = !modal_ciudad.visible">Cancelar
          </btn>&nbsp;
          <btn type="button" class="btn btn-primary" @click="
            updateCiudad(
              modal_ciudad.contacto_selected,
              modal_ciudad.ciudad_selected
            )
            " :disabled="modal_ciudad.ciudad_selected == null ||
              modal_ciudad.ciudad_selected.id == null ||
              modal_ciudad.contacto_selected == null
              ">{{ contacto.id ? "Editar" : "Guardar" }}</btn>&nbsp;
        </span>
      </modal>

      <!-- Demografico -->
      <modal class="modal" v-model="modal_demografico">
        <form @submit.prevent="addDemografico">
          <div class="container">
            <div class="row mt-2">
              <label for="valor" class="col-3 control-label text-right">
                <strong>Fecha nacimiento</strong>
              </label>
              <div class="col-9">
                <date-picker id="datepicker" v-model="fecha" :placeholder="'aaaa/mm/dd'" :bootstrap-styling="true"
                  :clear-button="true" format="yyyy-MM-dd" :language="es"></date-picker>
              </div>
            </div>
          </div>

          <div class="container" v-for="(row, index) in option" :key="index">
            <div class="row mt-2">
              <label for="valor" class="col-3 control-label text-right">
                <strong>{{ row.titulo }}</strong>
              </label>
              <div class="col-9">
                <select v-model="row.input" class="form-control" required>
                  <option :value="null">Seleccione ...</option>
                  <option v-for="(v, i) in row.values" :key="i">
                    {{ v.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </form>
        <span slot="footer">
          <btn type="button" class="btn btn-primary" @click="resetSocioDemografica()">Cancelar</btn>&nbsp;
          <btn type="button" class="btn btn-primary" @click="addDemografico">{{
            update ? "Editar" : "Guardar"
          }}</btn>&nbsp;
        </span>
      </modal>
      <!-- Fin demografica -->



      <!-- Modal autorizacion contacto -->
      <modal class="modal" v-model="modal_tipo_notificacion.visible" title="Tipo notificación">
        <form @submit.prevent="updateAuthContacto">
          <div class="row mt-2">
            <ul class="custom-list">
              <p>
                <strong>Seleccione uno o varios elementos de la lista:</strong>
              </p>
              <li v-if="modal_tipo_notificacion.contacto.descripcion != 'email'">
                <input :disabled="loading" type="checkbox" v-model="modal_tipo_notificacion.selectAll"
                  @change="toggleAllModalTipoNotificacion">Todos <br>
              </li>
              <li v-for="(option, index) in modal_tipo_notificacion.contacto.tipo_notificacion" :key="index">
                <label>
                  <input :disabled="loading" type="checkbox" v-model="option.check"
                    @change="verifyCheckModalTipoNotificacion" :value="option.check"> {{ option.titulo }}
                </label>
              </li>
            </ul>
          </div>

          <div class="row mt-2">
            <ul class="custom-list">
              <p>
                <strong>Seleccione uno o varios contactos de la lista:</strong>
              </p>
              <li v-if="modal_tipo_notificacion.contacto.descripcion != 'email'">
              </li>
              <li v-for="(value, index) in modal_tipo_notificacion.lista_contactos" :key="index">
                <label>
                  <input :disabled="loading || value.lock" type="checkbox" v-model="value.update" :value="value.update">
                  {{ value.valor }}
                </label>
              </li>
            </ul>
          </div>
        </form>
        <span slot="footer">
          <btn type="button" class="btn btn-primary" @click="resetTipoNotificacion">Cancelar</btn>&nbsp;
          <btn type="button" class="btn btn-primary" @click="guardarTipoNotificacion">Guardar</btn>&nbsp;
        </span>
      </modal>
      <!-- Fin modal autorizacion contacto-->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

export default {
  name: "Contacto",
  data: () => {
    return {
      modal: false,
      modal_demografico: false,
      modal_demografico_permiso: true,
      contacto: {},
      data_telefono: [
        { titulo: 'Teléfono', value: "telefono", check: false },
        { titulo: 'WhatsApp', value: "whatsapp", check: false },
        { titulo: 'SMS', value: "sms", check: false },
      ],
      data_email: [
        { titulo: 'Correo electrónico', value: "correo_electronico", check: false },
      ],
      es: es,
      fecha: null,
      fecha_nacimiento: null,
      response: [],
      update: false,
      validate_demografica: true,
      option: [
        {
          titulo: "Estado civil",
          input: null,
          name: "estado_civil",
          values: [
            { value: "Soltero/a" },
            { value: "Casado/a" },
            { value: "Divorciado/a" },
            { value: "Viudo/a" },
            { value: "Unión libre" },
          ],
        },
        {
          titulo: "Nivel académico",
          input: null,
          name: "nivel_academico",
          values: [
            { value: "No bachiller" },
            { value: "Bachiller" },
            { value: "Técnico" },
            { value: "Tecnólogo" },
            { value: "Universitario" },
            { value: "Posgrado" },
          ],
        },
        {
          titulo: "Situación laboral",
          input: null,
          name: "situacion_laboral",
          values: [
            { value: "Estudiante" },
            { value: "Independiente" },
            { value: "Empleado/a" },
            { value: "Sin empleo no estoy en búsqueda de trabajo" },
            { value: "Sin empleo estoy en búsqueda de trabajo" },
            { value: "Jubilado/a" },
            { value: "Discapacitado/a, no puedo trabajar" },
          ],
        },
        {
          titulo: "Nivel de ingresos",
          input: null,
          name: "nivel_ingreso",
          values: [
            { value: "Inferior a 1 SMMLV" },
            { value: "Entre 1 y 2 SMMLV" },
            { value: "Entre 2 y 3 SMMLV" },
            { value: "Entre 3 y 4 SMMLV" },
            { value: "Mayor que 4 SMMLV" },
          ],
        },
        {
          titulo: "Estrato",
          input: null,
          name: "estrato",
          values: [
            { value: 1 },
            { value: 2 },
            { value: 3 },
            { value: 4 },
            { value: 5 },
            { value: 6 },
          ],
        },
      ],
      modal_ciudad: {
        visible: false,
        contacto_selected: {},
        ciudad_selected: null,
        target: null,
        ciudades: [],
      },
      modal_tipo_notificacion: {
        visible: false,
        selectAll: false,
        contacto: {},
        lista_contactos: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      deudor: "deudor/deudor",
      loading: "loading",
      obligaciones: "deudor/obligaciones",
      contactos: "gestion/infoContacto",
    }),
    contacto_last_update: {
      get() {
        let last_update = "00:00:00 00:00:00";
        let tipos = ["telefono", "email", "direccion"];

        if (this.contactos == null) {
          return last_update;
        }

        tipos.forEach((tipo) => {
          if (this.contactos[tipo] != null && this.contactos[tipo].length) {
            this.contactos[tipo].forEach((element) => {
              if (last_update <= element.updated_at) {
                last_update = element.updated_at;
              }
            });
          }
        });

        return last_update;
      },
    },
  },
  components: {
    Timer: () => import("@/components/timer/Timer"),
    "date-picker": Datepicker,
  },
  methods: {
    async guardarTipoNotificacion() {
      let data_update = [];
      let updates = 0;
      this.modal_tipo_notificacion.visible = false;
      let contacto_save = Object.assign({}, this.modal_tipo_notificacion.contacto);

      this.modal_tipo_notificacion.lista_contactos.forEach(element => {
        if (element.update === true) {
          element.tipo_notificacion = contacto_save.tipo_notificacion;
          data_update.push(element);
        }
      });

      data_update.forEach(element => {
        this.$store
          .dispatch("edit", {
            endpoint: "contacto/" + element.id,
            params: element,
          }).then((response) => {
            updates++;
            if (data_update.length == updates) {
              this.$notify({
                title: "Actualización completada!",
                type: "success",
                content:
                  "Se han actualizandos los contactos correctamente",
              });

              this.$store
                .dispatch("index", {
                  endpoint: "contacto",
                  params: { deudor_id: this.deudor.id },
                })
                .then((response) => {
                  this.$store.dispatch("gestion/refreshInfoContacto", response);
                })
                .catch(() => {
                  this.$notify({
                    title: "Advertencia!",
                    type: "danger",
                    content:
                      "Se ha presentado un error consultando la información de contacto",
                  });
                });
              this.resetTipoNotificacion();
            }
          }).catch((err) => {
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content: "Ha ocurrido un problema actualizando el contacto con valor " + data.valor,
            });
          })
      });
    },
    resetTipoNotificacion() {
      this.modal_tipo_notificacion = {
        visible: false,
        selectAll: false,
        contacto: {},
        lista_contactos: [],
      };
    },
    toggleAllModalTipoNotificacion() {
      if (this.modal_tipo_notificacion.selectAll) {
        this.modal_tipo_notificacion.contacto.tipo_notificacion.forEach(element => {
          element.check = true;
        });
      } else {
        this.modal_tipo_notificacion.contacto.tipo_notificacion.forEach(element => {
          element.check = false;
        });
      }
    },
    verifyCheckModalTipoNotificacion() {
      let checkeds = this.modal_tipo_notificacion.contacto.tipo_notificacion.filter(elemento => elemento.check == true);

      if (this.modal_tipo_notificacion.contacto.tipo_notificacion.length == checkeds.length) {
        this.modal_tipo_notificacion.selectAll = true;
        this.toggleAllModalTipoNotificacion();
      } else {
        this.modal_tipo_notificacion.selectAll = false;
      }
    },
    modalTipoContacto(campo) {
      this.resetTipoNotificacion();
      this.modal_tipo_notificacion.contacto = Object.assign({}, campo);
      if (this.modal_tipo_notificacion.contacto.descripcion == 'telefono') {
        this.modal_tipo_notificacion.lista_contactos = this.contactos.telefono;
        this.modal_tipo_notificacion.lista_contactos.forEach(element => {
          if (element.id == this.modal_tipo_notificacion.contacto.id) {
            element.update = true;
            element.lock = true;
          } else {
            element.update = false;
            element.lock = false;
          }
        });
      }
      if (this.modal_tipo_notificacion.contacto.descripcion == 'email') {
        this.modal_tipo_notificacion.lista_contactos = this.contactos.email;
        this.modal_tipo_notificacion.lista_contactos.forEach(element => {
          if (element.id == this.modal_tipo_notificacion.contacto.id) {
            element.update = true;
            element.lock = true;
          } else {
            element.update = false;
            element.lock = false;
          }
        });
      }
      if (this.modal_tipo_notificacion.contacto.tipo_notificacion === null) {
        switch (campo.descripcion) {
          case "telefono":
            this.modal_tipo_notificacion.contacto.tipo_notificacion = [
              { titulo: 'Teléfono', value: "telefono", check: false },
              { titulo: 'WhatsApp', value: "whatsapp", check: false },
              { titulo: 'SMS', value: "sms", check: false },
            ];
            break;
          case "email":
            this.modal_tipo_notificacion.contacto.tipo_notificacion = [
              { titulo: 'Correo electrónico', value: "correo_electronico", check: false },
            ];
            break;
          default:
            break;
        }
      }
      this.verifyCheckModalTipoNotificacion();
      this.modal_tipo_notificacion.visible = true;
    },
    likeContacto(contacto) {
      if (this.loading) return;
      this.$store
        .dispatch("index", { endpoint: "contacto/" + contacto.id })
        .then((response) => {
          contacto.calificacion = response.calificacion + 1;
          contacto.calificado = true;
          this.$store
            .dispatch("edit", {
              endpoint: "contacto/" + contacto.id,
              params: contacto,
            })
            .then((response) => {
              this.$notify({
                title: "Calificación!",
                type: "success",
                content:
                  "Se calificó el contacto " +
                  response.descripcion +
                  " satisfactoriamente",
              });
            })
            .catch(() => {
              this.$notify({
                title: "Advertencia!",
                type: "warning",
                content: "Ha ocurrido un problema calificando el contacto",
              });
            });
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema calificando el contacto",
          });
        });
    },
    marcarNotificable(contacto) {
      if (this.loading) return;

      this.$store
        .dispatch("index", { endpoint: "contacto/" + contacto.id })
        .then((response) => {
          contacto.notificable = !contacto.notificable;
          this.$store
            .dispatch("edit", {
              endpoint: "contacto/" + contacto.id,
              params: contacto,
            })
            .then((response) => {
              this.$notify({
                title: "Marcar como Notificable!",
                type: "success",
                content:
                  "Se marcó el contacto como " +
                  (contacto.notificable ? "" : "No ") +
                  " notificable",
              });
            })
            .catch(() => {
              this.$notify({
                title: "Advertencia!",
                type: "warning",
                content: "Ha ocurrido un problema almacenando la información",
              });
            });
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema almacenando la información",
          });
        });
    },
    dislikeContacto(contacto) {
      if (this.loading) return;
      this.$store
        .dispatch("index", { endpoint: "contacto/" + contacto.id })
        .then((response) => {
          contacto.calificacion = contacto.calificacion - 1;
          contacto.calificado = true;
          this.$store
            .dispatch("edit", {
              endpoint: "contacto/" + contacto.id,
              params: contacto,
            })
            .then((response) => {
              this.$notify({
                title: "Calificación!",
                type: "success",
                content:
                  "Se calificó el contacto " +
                  response.descripcion +
                  " satisfactoriamente",
              });
            })
            .catch(() => {
              this.$notify({
                title: "Advertencia!",
                type: "warning",
                content: "Ha ocurrido un problema calificando el contacto",
              });
            });
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema calificando el contacto",
          });
        });
    },
    invalidarContacto(contacto) {
      if (this.loading) return;
      if (contacto.invalido) {
        alert("Este dato ya fue reportado como inválido");
        return false;
      }
      //contacto.invalido = !contacto.invalido;
      if (
        !confirm(
          "¿En realidad desea marcar el dato " +
          contacto.valor +
          " como inválido?"
        )
      ) {
        return false;
      }
      contacto.invalido = 1;
      this.$store
        .dispatch("edit", {
          endpoint: "contacto/" + contacto.id,
          params: contacto,
        })
        .then((response) => {
          this.$notify({
            title: "Invalidado!",
            type: "success",
            content:
              "Se invalidó el contacto " +
              response.descripcion +
              " satisfactoriamente",
          });
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema invalidando el contacto",
          });
        });
    },
    externalCall(phone_code, phone) {
      this.$store.dispatch("vicidial/external_call", {
        phone_code: phone_code,
        value: phone,
      });
    },
    resetValuesTipoContacto() {
      this.data_telefono = [
        { titulo: 'Teléfono', value: "telefono", check: false },
        { titulo: 'WhatsApp', value: "whatsapp", check: false },
        { titulo: 'SMS', value: "sms", check: false },
      ];

      this.data_email = [
        { titulo: 'Correo electrónico', value: "correo_electronico", check: false },
      ];

      this.contacto = {};
    },
    addContacto() {
      if (this.contacto.descripcion == 'email') {
        this.contacto.tipo_notificacion = this.data_email;
      }

      if (this.contacto.descripcion == 'telefono') {
        this.contacto.tipo_notificacion = this.data_telefono;
      }

      this.contacto.deudor_id = this.deudor.id;
      this.contacto.notificable = 0;
      this.$store
        .dispatch("store", { endpoint: "contacto", params: this.contacto })
        .then((response) => {
          this.$notify({
            title: "Contacto!",
            type: "success",
            content: "Se guardó el contacto satisfactoriamente",
          });
          this.modal = !this.modal;
          this.getInformacionContacto(this.deudor.id);
          this.resetValuesTipoContacto();
        })
        .catch(() => {
          this.resetValuesTipoContacto();
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema guardando el contacto",
          });
        });
    },
    addDemografico() {
      this.modal_demografico_permiso = false;
      this.modal_demografico = false;
      let data = {};
      data.usuario_id = this.$store.state.user.user.id;

      if (
        this.fecha_nacimiento != "" &&
        this.fecha_nacimiento != "NaN-NaN-NaN"
      ) {
        data.fecha_nacimiento = this.fecha_nacimiento;
      }
      data.cedula = this.deudor.identificacion;

      this.option.forEach(function (element) {
        if (element.name == "estado_civil" && element.input != "") {
          data.estado_civil = element.input;
        }
        if (element.name == "nivel_academico" && element.input != "") {
          data.nivel_academico = element.input;
        }
        if (element.name == "situacion_laboral" && element.input != "") {
          data.situacion_laboral = element.input;
        }
        if (element.name == "nivel_ingreso" && element.input != "") {
          data.nivel_ingreso = element.input;
        }
        if (element.name == "estrato" && element.input != "") {
          data.estrato = element.input;
        }
      });

      if (typeof this.response.id == "undefined") {
        this.$store
          .dispatch("store", { endpoint: "sociodemografica", params: data })
          .then((response) => {
            this.$notify({
              title: "Inf. demografica!",
              type: "success",
              content: "Se guardó la información satisfactoriamente",
            });
            this.getSocioDemografica();
          })
          .catch((error) => {
            this.modal_demografico_permiso = false;
            this.modal_demografico = false;
            this.$notify({
              title: "Advertencia!",
              type: "danger",
              content:
                "Ha ocurrido un problema intentando guardar la información",
            });
          });
      } else {
        this.$store
          .dispatch("edit", {
            endpoint: "sociodemografica/" + this.response.id,
            params: data,
          })
          .then((response) => {
            this.modal_ciudad.visible = false;
            this.$notify({
              title: "Actualización completa",
              type: "success",
              content: "Se actualizó la información satisfactoriamente",
            });
            this.modal_ciudad.ciudad_selected = null;
            this.getSocioDemografica();
          })
          .catch(() => {
            this.modal_demografico_permiso = false;
            this.modal_demografico = false;
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content:
                "Ha ocurrido un problema intentando actualizar la información",
            });
          });
      }
      this.modal_demografico_permiso = true;
    },
    getInformacionContacto(documento) {
      this.$store
        .dispatch("index", {
          endpoint: "contacto",
          params: { deudor_id: documento },
        })
        .then((response) => {
          this.$store.dispatch("gestion/refreshInfoContacto", response);
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content:
              "Se ha presentado un error consultando la información de contacto",
          });
        });
    },
    openModalCiudad(campo) {
      this.modal_ciudad.visible = true;
      this.modal_ciudad.contacto_selected = campo;
    },
    updateCiudad(contacto, municipio) {
      if (contacto.id == null) {
        return false;
      }
      if (municipio.id == null) {
        return false;
      }
      contacto.municipio_id = municipio.id;
      this.$store
        .dispatch("edit", {
          endpoint: "contacto/" + contacto.id,
          params: contacto,
        })
        .then((response) => {
          this.modal_ciudad.visible = false;
          this.$notify({
            title: "Invalidado!",
            type: "success",
            content: "Se actualizó la ciudad satisfactoriamente",
          });
          this.modal_ciudad.ciudad_selected = null;
          this.getInformacionContacto(this.deudor.id);
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema intentando actualizar la ciudad",
          });
        });
      return false;
    },
    async getCiudades() {
      if (this.modal_ciudad.ciudades.length > 0) {
        return this.modal_ciudad.ciudades;
      }
      try {
        let request = await this.$store.state.api.get("/municipio", {
          params: {
            paginar: false,
          },
        });

        request.data.datos.forEach((element) => {
          this.modal_ciudad.ciudades.push({
            id: element.id,
            name: element.municipio + " - " + element.departamento,
          });
        });
        return this.modal_ciudad.ciudades;
      } catch (err) {
        console.log(err);
      }
    },
    getSocioDemografica() {
      let id = this.deudor.id;
      this.response = {};

      this.$store
        .dispatch("index", {
          endpoint: "sociodemografica",
          params: { deudor_id: id },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            this.update = true;
            this.response = response.datos[response.datos.length - 1];
            this.resetSocioDemografica();
          } else {
            this.update = false;
            this.response = {
              estado_civil: null,
              nivel_academico: null,
              situacion_laboral: null,
              nivel_ingreso: null,
              estrato: null,
              fecha_nacimiento: null,
            };
            this.resetSocioDemografica();
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content:
              "Se ha presentado un error consultando la información de contacto",
          });
        });
    },
    resetSocioDemografica() {
      this.option.forEach((element) => {
        if (element.name == "estado_civil") {
          element.input = this.response.estado_civil;
        }

        if (element.name == "nivel_academico") {
          element.input = this.response.nivel_academico;
        }

        if (element.name == "situacion_laboral") {
          element.input = this.response.situacion_laboral;
        }

        if (element.name == "nivel_ingreso") {
          element.input = this.response.nivel_ingreso;
        }

        if (element.name == "estrato") {
          element.input =
            this.response.estrato != 0 ? this.response.estrato : "";
        }
      });

      this.fecha = this.response.fecha_nacimiento;
      this.modal_demografico = !this.modal_demografico;
      this.modal_demografico_permiso = true;
    },
    consultaAmpliada() {
      this.$router.push({ path: "/informacion-ampliada/" + this.deudor.identificacion });
    },
  },
  watch: {
    fecha: function (newVal) {
      if (newVal == null) {
        this.fecha_nacimiento = newVal;
      } else {
        var d = new Date(newVal),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        this.fecha_nacimiento = [year, month, day].join("-");
      }
    },
  },
  mounted() {
    this.getCiudades();
  },
};
</script>
<style>
#datepicker {
  background: white;
  padding-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.typehead ul {
  right: 0px;
  right: 0px;
  left: auto;
  width: max-content;
}

.typehead li {
  padding: 5px;
}

.typehead a {
  color: black;
}

.typehead .active a,
.typehead a:hover {
  color: #60a7cb !important;
}

.custom-list {
  list-style-type: none;
  /* Esto quitará el punto de la lista */
  list-style-type: none;
  padding: 50px, 50px, 0px, 50px;
  /* Elimina el relleno predeterminado de la lista */
}

.custom-list li {
  min-height: 30px;
  /* Establece una altura mínima para los elementos de la lista */
  display: flex;
  /* Usa flexbox para alinear verticalmente el contenido */
  align-items: center;
  /* Centra verticalmente el contenido dentro de los elementos de la lista */
}
</style>